<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconWaiting_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <circle cx="17.6" cy="7.6" r="3.6" fill="currentColor" />
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.84 6.546h9.07q-.091.44-.092.909a4.546 4.546 0 0 0 6.364 4.167v5.719a2.844 2.844 0 0 1-2.841 2.84H4.84A2.844 2.844 0 0 1 2 17.342V9.386a2.844 2.844 0 0 1 2.84-2.84m5.946 7.26a2.724 2.724 0 0 0 2.72-2.721c0-1.5-1.22-2.721-2.72-2.721s-2.723 1.22-2.723 2.72a2.725 2.725 0 0 0 2.723 2.723m4.456 2.487c-.71-.76-2.048-1.323-4.457-1.323-2.428 0-3.77.574-4.474 1.343l-.018.02c-.191.207-.5.543-.629 1.37a.743.743 0 0 0 .734.85h8.775a.743.743 0 0 0 .734-.851c-.13-.837-.447-1.176-.652-1.396z"
        clip-rule="evenodd"
    />
    <path
        fill="currentColor"
        d="M18.364 3.818a3.636 3.636 0 1 0 0 7.273 3.636 3.636 0 0 0 0-7.273m1.932 4.697a.39.39 0 0 1-.53.154l-1.59-.873a.39.39 0 0 1-.202-.341V4.857a.39.39 0 0 1 .78 0v2.367l1.387.763a.39.39 0 0 1 .155.528"
    />
</svg>
